<template>
	<div class="p-col-12 p-grid">
		<div class="p-col-12 p-lg-6" :class="[commonService.isMobile() ? 'text-box-mobile' : 'text-box']">
			<p>For the Agent</p>
			<p class="login-subtitle">Why choose The TiroLibre transfer platform?</p>
			<p v-if="!commonService.isMobile()" class="login-text justified">Having a wide network of Club selectors concentrated in a single platform is crucial. More than 5000 clubs from all over Europe receive daily recommendations from TiroLibre and initiate real-time negotiations.</p>
			<p v-if="!commonService.isMobile()" class="login-text justified">Stay ahead of the competition during this crucial summer transfer window by swiftly negotiating deals with numerous key executives, all in one place.</p>
			<p v-if="commonService.isMobile()" class="login-text justified">Having access to a broad network of Club selectors in one location is critical.</p>
			<p v-if="commonService.isMobile()" class="login-text justified">Over 5000 clubs from all over Europe get daily advice from TiroLibre and initiate real-time negotiations.</p>
			<div v-if="!commonService.isMobile()" :class="isSmallScreen()? 'p-col-5 button-box' : 'p-lg-3 button-box'" style="padding: 0px">
				<Button label="Become an associate" class="p-button-warning" style="color: white; font-weight: bold;" @click="toLogin" />
			</div>
		</div>
		<div class="p-col-12 p-lg-6" style="margin: auto">
			<div class="card card-w-title" style="width: 100%;">
				<Toast />
				<div class="p-grid">
					<img :src="commonService.getHomeAgent2ImageUrl()" alt="" style="width: 90%; margin: auto">
				</div>
			</div>
			<div v-if="commonService.isMobile()" class="p-col-8 button-box-mobile" style="margin-top: -30px; margin-bottom: 30px">
				<Button label="Become an associate" class="p-button-warning" style="color: white; font-weight: bold;" @click="toLogin" />
			</div>
		</div>
	</div>
</template>

<script>
import CommonService from "@/service/CommonService";

export default {
	commonService: null,
	created() {
		this.commonService = new CommonService();
	},
	methods: {
		toLogin() {
			this.$router.push("/login");
		},
		isSmallScreen() {
			return screen.width <= 1600 ? true : false;
		},
	},
};
</script>

<style scoped>
.justified {
	text-align: justify;
	text-justify: inter-word;
}

.login-title {
	margin-top: -15px;
	font-size: 65px;
	font-weight: bold;
}

.login-subtitle {
	margin-top: -10px;
	font-size: xx-large;
	font-weight: bold;
}

.login-text {
	margin-top: 10px;
	font-size: 19px;
}

.text-box {
	margin: auto;
	padding-left: 50px;
}

.text-box-mobile {
	margin: auto;
}

.button-box {
	margin-top: 20px;
}

.button-box-mobile {
	margin: auto;
}

@media (min-width: 0px) and (max-width: 1000px) {
	.login-title {
		margin-top: -15px;
		font-size: 45px;
		font-weight: bold;
	}

	.login-subtitle {
		margin-top: -0px;
		font-size: x-large;
		font-weight: bold;
	}

	.login-text {
		margin-top: 10px;
		font-size: 16px;
	}
}
</style>